import request from '@/utils/httpjavaRequest'

//查询仪器
export function instrument(query) {
    return request({
        url: '/colortools/apparatus/pageQuery',
        method: 'post',
        data:query
    });
  }
//获取品牌列表
export function brandlist() {
    return request({
        url: '/colortools/apparatus/brandList',
        method: 'get',
    });
}

  //获取荧光素
export function fluorelist() {
    return request({
        url: '/colortools/fluorescein/list',
        method: 'post',
    });
}
//新增或修改仪器
export function instrumentadd(query) {
    return request({
        url: '/colortools/apparatus/saveOrUpdate',
        method: 'post',
        data:query
    });
}
//批量删除仪器
export function instrudelete(query) {
    return request({
        url: '/colortools/apparatus/batchDelete',
        method: 'put',
        data:query
    });
}
//获取种属
export function genuslist() {
    return request({
        url: '/colortools/antigen/species',
        method: 'get',
    });
}
//抗原列表查询
export function antigenlist(query) {
    return request({
        url: '/colortools/antigen/pageQuery',
        method: 'post',
        data:query
    });
}
//新增抗原
export function antigenadd(query) {
    return request({
        url: '/colortools/antigen/saveOrUpdate',
        method: 'post',
        data:query
    });
}

//批量删除抗原
export function antigendelete(query) {
    return request({
        url: '/colortools/antigen/batchDelete',
        method: 'put',
        data:query
    });
}
//批量删除荧光素
export function fluoresceindelete(query) {
    return request({
        url: '/colortools/fluorescein/batchDelete',
        method: 'put',
        data:query
    });
}
//荧光素列表查询
export function fluoresceinlist(query) {
    return request({
        url: '/colortools/fluorescein/pageQuery',
        method: 'post',
        data:query
    });
}
//新增荧光素
export function fluoresceinadd(query) {
    return request({
        url: '/colortools/fluorescein/saveOrUpdate',
        method: 'post',
        data:query
    });
}
//获取抗原列表
export function antigenGetlist(query) {
    return request({
        url: '/colortools/antigen/list',
        method: 'post',
        data:query
    });
}
//获取仪器列表
export function apparatusGetlist(query) {
    return request({
        url: '/colortools/apparatus/list',
        method: 'post',
        data:query
    });
}

//获取荧光素列表
export function apparatusGetfluo(query) {
    return request({ 
        url: '/colortools/apparatus/fluoresceinList',
        method: 'post',
        data:query
    });
}

//分页查询配色方案
export function schemelist(query) {
    return request({ 
        url: '/colortools/scheme/pageQuery',
        method: 'post',
        data:query
    });
}
//下载
export function schemepath() {
    return request({
        url: '/colortools/scheme/template/path',
        method: 'get',
    });
}
//上传
export function schemeupload(query) {
    return request({ 
        url: '/colortools/scheme/import',
        method: 'post',
        data:query
    });
}
//主页面配色列表数据
export function finalschemelist(query) {
    return request({ 
        url: '/colortools/scheme/matchColors',
        method: 'post',
        data:query
    });
}
//主页面配色列表导出
export function finalschemeupload(query) {
    return request({ 
        url: '/colortools/scheme/matchColors/export',
        method: 'post',
        data:query
    });
}
//根据货号查询目录价
export function getGoodsDet(query) {
    return request({ 
        url: '/colortools/scheme/utGoods/get?goodsSn='+query,
        method: 'get',
    });
}
//根据仪器查询通道
export function getPassage(query) {
    return request({ 
        url: '/colortools/apparatus/passageList?appId='+query,
        method: 'get',
    });
}
//辅助试剂下载
export function reagentpath(query) {
    return request({
        url: '/colortools/scheme/auxiliaryReagent/export',
        method: 'post',
        data:query
    });
}
//保存配色方案
export function getschemesave(query) {
    return request({
        url: '/colortools/schemeLog/save',
        method: 'post',
        data:query
    });
}
//配色方案历史
export function getHistory(query) {
    return request({
        url: '/colortools/schemeLog/pageQuery',
        method: 'post',
        data:query
    });
}
//根据仪器查询通道
export function getDetails(query) {
    return request({ 
        url: '/colortools/schemeLog/getById?id='+query,
        method: 'get',
    });
}
//自由通道
export function getScheme(query) {
    return request({ 
        url: '/colortools/scheme/freePassageList',
        method: 'get',
    });
}
//自由通道
export function getuplode(query) {
    return request({ 
        url: '/colortools/schemeLog/export?id='+query,
        method: 'get',
    });
}
//合并下载
export function mergeUplode(query) {
    return request({
        url: '/colortools/scheme/mergeResult/export',
        method: 'post',
        data:query
    });
}
//指定荧光素
export function speFluore(query,data) {
    return request({ 
        url: '/colortools/scheme/specifyFluorescein?fluorescein='+query+'&species='+data,
        method: 'get',
    });
}
//指定货号
export function speArtNo(query) {
    return request({ 
        url: '/colortools/scheme/specifyArtNo?artNo='+query,
        method: 'get',
    });
}

// 方案 获取荧光素列表
export function progluciferin(query) {
    return request({
        url: '/colortools/scheme/fluorescein/list',
        method: 'post',
        data:query
    });
}
// 方案 获取货号列表
export function progartNo(query) {
    return request({
        url: '/colortools/scheme/artNo/list',
        method: 'post',
        data:query
    });
}
//看日志
export function getJournal(query) {
    return request({
        url: '/colortools/schemeOplog/pageQuery',
        method: 'post',
        data:query
    });
}
//看报表
export function getForm(query) {
    return request({
        url: '/colortools/scheme/report',
        method: 'post',
        data:query
    });
}
//报表导出
export function getFormupload(query) {
    return request({
        url: '/colortools/scheme/report/export',
        method: 'post',
        data:query
    });
}
//方案修改保存
export function saveOrUpdate(query) {
    return request({
        url: '/colortools/scheme/saveOrUpdate',
        method: 'post',
        data:query
    });
}

//根据货号获取产品信息
export function productInfo(query,data) {
    return request({ 
        url: '/colortools/scheme/productInfo?artNo='+query,
        method: 'get',
    });
}


// WEBPACK FOOTER //
// ./src/view/product/api/luciferinmg.js